import React, { useEffect, useState, useRef } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  TextField,
  Button,
  Chip,
  Box,
  Card,
  Container,
  MenuItem,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  Paper,
  TableHead,
  Table,
  TablePagination,
  Alert,
  AlertTitle,
  Checkbox,
  ListItemText,
  Autocomplete,
  FormControl,
  Backdrop,
  CircularProgress
} from "@mui/material";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ListIcon from "@mui/icons-material/List";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./index.css";
import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { format } from "date-fns";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DescriptionIcon from "@mui/icons-material/Description";

const CapacityBulkUpload = () => {
  const [dateRange, setDateRange] = useState(["", ""]);
  const [startDate, endDate] = dateRange;
  const [stores, setStores] = useState([]);
  const [selectedCodes, setSelectedCodes] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);
  const [tableData, setTableData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [total, setTotal] = useState(0);
  const [selectedStoreType, setSelectedStoreType] = useState([]);
  const [loading, setLoading] = useState(false);
  const storeTypeOptions = [
    { label: "All", value: "all" },
    { label: "SM", value: "SM" },
    { label: "HM", value: "HM" },
    { label: "DS", value: "DS" },
  ];

  const handleGetStores = async () => {
    try {
      const response = await axios.get(
        "https://45da4uqkcc.execute-api.ap-south-1.amazonaws.com/default/get_stores",
        {
          params: {
            store_type:
              selectedStoreType.includes("all") ||
                selectedStoreType.length === 0
                ? "all"
                : selectedStoreType.join(","),
          },
          headers: {
            Authorization: Cookies.get("ssp_sso_token"),
            "content-type": "application/json",
          },
        }
      );
      if (response?.data?.success) {
        setStores(response?.data?.data);
      } else {
        toast.error("Something went wrong, please try again later!", {
          position: "top-right",
        });
        return;
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong, please try again later!");
    }
  };

  const handleGetLogs = async () => {
    try {
      const response = await axios.get(
        "https://45da4uqkcc.execute-api.ap-south-1.amazonaws.com/default/get_logs",
        {
          params: {
            page: page + 1,
            perPage: rowsPerPage,
          },
          headers: {
            Authorization: Cookies.get("ssp_sso_token"),
            "content-type": "application/json",
          },
        }
      );
      if (response?.data?.success) {
        setTableData(response?.data?.data);
        setTotal(response?.data?.total);
      } else {
        toast.error("Something went wrong, please try again later!", {
          position: "top-right",
        });
        return;
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong, please try again later!", {
        position: "top-right",
      });
    }
  };

  const uniqueStores = Array.from(
    new Map(stores.map((store) => [store.store_name, store])).values()
  );
  const handleChanges = (event, value) => {
    const selectedValues = value.map((store) => store.store_code);
    if (selectedValues.includes("all")) {
      // If "Select All" is selected, toggle between all stores or none
      setSelectedCodes(
        selectedCodes.length === uniqueStores.length
          ? []
          : uniqueStores.map((store) => store.store_code)
      );
    } else {
      setSelectedCodes(selectedValues);
    }
  };

  const isAllSelected = selectedCodes.length === uniqueStores.length;

  // Map selected store codes to store objects for Autocomplete
  const selectedStores = selectedCodes
    .map((code) => uniqueStores.find((store) => store.store_code === code))
    .filter(Boolean);

  const handleDownloadFile = async () => {
    if (!selectedCodes.length > 0) {
      toast.error("Please select all fields", { position: "top-right" });
      return;
    }
    try {
      setLoading(true);
      const response = await axios.get(
        "https://45da4uqkcc.execute-api.ap-south-1.amazonaws.com/default/download_slots",
        {
          params: {
            start_date: format(new Date(startDate), "yyyy-MM-dd"),
            end_date: format(new Date(endDate), "yyyy-MM-dd"),
            storeCode: JSON.stringify(selectedCodes.map(Number)),
          },
          headers: {
            Authorization: Cookies.get("ssp_sso_token"),
            "content-type": "application/json",
          },
        }
      );
      if (response?.data?.success) {
        window.open(response?.data?.download_url, "_blank");
        setLoading(false);
      } else {
        toast.error("Something went wrong, please try again later!", {
          position: "top-right",
        });
        setLoading(false);
        return;
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong, please try again later!", {
        position: "top-right",
      });
      setLoading(false);
    }
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };
  const handleChooseFile = () => {
    fileInputRef.current.click();
  };
  const handleChange = (event, newValue) => {
    const selectedValues = newValue.map((option) => option.value);
    const allIndividualOptions = storeTypeOptions
      .filter((option) => option.value !== "all")
      .map((option) => option.value);

    if (selectedValues.includes("all") && !selectedStoreType.includes("all")) {
      setSelectedStoreType(["all"]);
      return;
    }
    if (selectedStoreType.includes("all") && !selectedValues.includes("all")) {
      setSelectedStoreType([]);
      return;
    }
    if (allIndividualOptions.every((value) => selectedValues.includes(value))) {
      setSelectedStoreType(["all"]);
    } else {
      setSelectedStoreType(selectedValues.filter((value) => value !== "all"));
    }
  };

  const handleUpload = async () => {
    if (!selectedFile?.name) {
      toast.error("Please select a file", { position: "top-right" });
      return;
    }
    try {
      setLoading(true);
      const response = await axios.get(
        "https://45da4uqkcc.execute-api.ap-south-1.amazonaws.com/default/upload_to_s3",
        {
          params: {
            filename: selectedFile?.name,
          },
          headers: {
            Authorization: Cookies.get("ssp_sso_token"),
            "content-type": "application/json",
          },
        }
      );
      if (response?.data?.success) {
        const presignedUrl = response?.data?.response?.url;
        const fields = response?.data?.response?.fields;
        const formData = new FormData();
        Object.entries(fields).forEach(([key, value]) => {
          formData.append(key, value);
        });
        formData.append("file", selectedFile);
        const uploadResponse = await axios.post(presignedUrl, formData);
        if (uploadResponse?.status == 204) {
          const result = await axios.post(
            "https://45da4uqkcc.execute-api.ap-south-1.amazonaws.com/default/bulk_upload",
            {
              key: response?.data?.response?.fields?.key,
              upload_by: Cookies.get("ssp_domain_id"),
              update_date: new Date(Date.now()).toISOString().split("T")[0],
            },
            {
              headers: {
                Authorization: Cookies.get("ssp_sso_token"),
                "content-type": "application/json",
              },
            }
          );
          if (result?.data.success == true) {
            toast.success("File uploaded successfully", {
              position: "top-right",
            });
            setLoading(false);
            return;
          } else {
            toast.error(result?.data?.error, { position: "top-right" });
            setLoading(false);
            return;
          }
        } else {
          toast.error("Something went wrong, please try again later!", {
            position: "top-right",
          });
          setLoading(false);
          return;
        }
      } else {
        toast.error("Something went wrong, please try again later!", {
          position: "top-right",
        });
        setLoading(false);
        return;
      }
    } catch (error) {
      console.log(error);
      toast.error(
        error?.response?.data?.error ||
        "Something went wrong, please try again later!",
        {
          position: "top-right",
        }
      );
      setLoading(false);
    }
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const filterOptions = (options, { inputValue }) => {
    const input = inputValue.toLowerCase();
    return options.filter(
      (option) =>
        option.store_name.toLowerCase().includes(input) ||
        option.store_code.toString().includes(input)
    );
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    handleGetStores();
  }, [selectedStoreType]);

  useEffect(() => {
    handleGetLogs();
  }, [page, rowsPerPage]);

  return (
    <>
      {loading ? (
        <Backdrop
          sx={{
            zIndex: (theme) => theme.zIndex.drawer + 1,
            color: "#fff",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : null}
      <Container maxWidth="lg" sx={{ py: 4, mt: 4 }}>
        <Card sx={{ p: 3, boxShadow: 3, borderRadius: "12px" }}>
          <Typography variant="h5" sx={{ fontWeight: "bold", mb: 1 }}>
            Capacity Bulk Upload
          </Typography>
          <Alert
            severity="info"
            sx={{
              backgroundColor: "#E6F0FA",
              color: "#1976D2",
              borderRadius: "8px",
              "& .MuiAlert-icon": {
                color: "#1976D2",
              },
            }}
          >
            <AlertTitle sx={{ display: "none" }} />
            Please enter values for picker cap considering both LM and Picker
            capacities for stores where LM and picking both are done by more.
          </Alert>
          <Accordion
            defaultExpanded
            sx={{
              border: "1px solid #E4E8EB",
              borderRadius: "8px",
              mb: 1,
              mt: 1,
              "&:before": { display: "none" },
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <CloudDownloadIcon sx={{ mr: 1, color: "#1976d2" }} />
              <Typography>Download File for Bulk Upload</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Box sx={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                <FormControl sx={{ width: 200, maxWidth: 200 }}>
                  <Autocomplete
                    multiple
                    disablePortal
                    id="store-type-selector"
                    options={storeTypeOptions}
                    getOptionLabel={(option) => option.label}
                    value={storeTypeOptions.filter((option) =>
                      selectedStoreType.includes("all")
                        ? true
                        : selectedStoreType.includes(option.value)
                    )}
                    onChange={handleChange}
                    disableCloseOnSelect
                    sx={{
                      "& .MuiAutocomplete-inputRoot": {
                        height: "3.5rem",
                        padding: "4px 8px",
                        "& .MuiAutocomplete-input": {
                          minHeight: "24px",
                        },
                      },
                    }}
                    PaperProps={{
                      sx: {
                        // maxHeight: 200,
                        overflowY: "auto",
                        borderRadius: 2,
                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                        height: "3.5rem",
                      },
                    }}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          size="small"
                          sx={{ marginRight: 1, padding: 0.5 }}
                          checked={selectedStoreType.includes("all") || selected}
                        />
                        <ListItemText
                          primary={option.label}
                          primaryTypographyProps={{ variant: "body2" }}
                        />
                      </li>
                    )}
                    renderTags={(value, getTagProps) =>
                      selectedStoreType.includes("all")
                        ? [
                          <Chip
                            key="all"
                            label="All"
                            deleteIcon={null}
                            {...getTagProps({ index: 0 })}
                            onDelete={undefined}
                            size="small"
                            sx={{
                              maxWidth: 80,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              margin: "2px",
                              height: 24,
                            }}
                          />,
                        ]
                        : value.map((option, index) => (
                          <Chip
                            key={option.value}
                            label={option.label}
                            deleteIcon={null}
                            {...getTagProps({ index })}
                            onDelete={undefined}
                            size="small"
                            sx={{
                              maxWidth: 80,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              margin: "2px",
                              height: 24,
                            }}
                          />
                        ))
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Store Type"
                        variant="outlined"
                        sx={{
                          "& .MuiInputLabel-root": { fontSize: "0.9rem" },
                          "& .MuiOutlinedInput-root": {
                            fontSize: "0.9rem",
                            "& fieldset": { borderColor: "grey.400" },
                            "&:hover fieldset": { borderColor: "primary.main" },
                          },
                        }}
                      />
                    )}
                  />
                </FormControl>
                <Autocomplete
                  multiple
                  options={[
                    { store_code: "all", store_name: "Select All" },
                    ...uniqueStores,
                  ]}
                  getOptionLabel={(option) => option.store_name}
                  value={selectedStores}
                  onChange={handleChanges}
                  disableCloseOnSelect
                  filterOptions={filterOptions}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Store"
                      sx={{
                        minWidth: 250,
                        maxWidth: 250,
                        "& .MuiInputBase-root": {
                          display: "flex",
                          alignItems: "center",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                        },
                        "& .MuiAutocomplete-endAdornment": {
                          position: "absolute",
                          right: 8,
                          top: "50%",
                          transform: "translateY(-50%)",
                        },
                      }}
                    />
                  )}
                  renderOption={(props, option, { selected }) => (
                    <MenuItem
                      {...props}
                      value={option.store_code}
                      sx={{
                        maxWidth: 250,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <Checkbox
                        checked={
                          option.store_code === "all" ? isAllSelected : selected
                        }
                      />
                      <ListItemText
                        primary={option.store_name}
                        primaryTypographyProps={{
                          style: {
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          },
                        }}
                      />
                    </MenuItem>
                  )}
                  renderTags={(value, getTagProps) =>
                    value.length > 0 && (
                      <Chip
                        label={
                          value.length === uniqueStores.length
                            ? "All Stores"
                            : value
                              .map((option) => option.store_name)
                              .join(", ")
                              .substring(0, 20) +
                            (value.length > 1 ? "..." : "")
                        }
                        {...getTagProps({ index: 0 })}
                        onDelete={
                          value.length === uniqueStores.length
                            ? undefined
                            : getTagProps({ index: 0 }).onDelete
                        }
                        sx={{
                          maxWidth: "200px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      />
                    )
                  }
                  ListboxProps={{
                    sx: {
                      maxWidth: 250,
                      maxHeight: 200,
                      overflowY: "auto",
                    },
                  }}
                />
                <DatePicker
                  selectsRange={true}
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(item) => setDateRange(item)}
                  className="date-range-input"
                  withPortal
                  placeholderText="Select Date Range"
                  minDate={new Date()}
                />
                <Button
                  variant="contained"
                  startIcon={<CloudDownloadIcon />}
                  style={{
                    backgroundColor: "#1976d2",
                    textTransform: "none",
                    borderRadius: "8px",
                    maxHeight: "60px",
                  }}
                  onClick={handleDownloadFile}
                >
                  Download File
                </Button>
              </Box>
            </AccordionDetails>
          </Accordion>

          <Accordion
            sx={{
              border: "1px solid #E4E8EB",
              borderRadius: "8px",
              mb: 1,
              "&:before": { display: "none" },
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <CloudDownloadIcon sx={{ mr: 1, color: "#1976d2" }} />
              <Typography>Upload Capacity Data in Bulk</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                {/* Hidden file input */}
                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                  accept=".xlsx,.xls" // Restrict to Excel files
                />

                {/* Choose File Button */}
                <Button
                  variant="contained"
                  startIcon={<DescriptionIcon />}
                  onClick={handleChooseFile}
                  style={{
                    backgroundColor: "#6B7280",
                    color: "white",
                    "&:hover": { backgroundColor: "#4B5563" },
                    textTransform: "none",
                  }}
                >
                  Choose File
                </Button>
                <Typography variant="body1">
                  {selectedFile ? selectedFile.name : "No File Selected"}
                </Typography>
                <Button
                  variant="contained"
                  startIcon={<CloudUploadIcon />}
                  onClick={handleUpload}
                  style={{
                    backgroundColor: "#1976d2",
                    color: "white",
                    "&:hover": { backgroundColor: "#EC4899" },
                    textTransform: "none",
                    cursor: "pointer",
                  }}
                >
                  Upload File
                </Button>
              </Box>
            </AccordionDetails>
          </Accordion>

          <Accordion
            sx={{
              border: "1px solid #E4E8EB",
              borderRadius: "8px",
              mb: 1,
              "&:before": { display: "none" },
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <ListIcon sx={{ mr: 1, color: "#666" }} />
              <Typography>Upload Logs</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <TableContainer
                component={Paper}
                sx={{ borderRadius: 2, boxShadow: 1 }}
              >
                <Table>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#E5E7EB" }}>
                      <TableCell sx={{ fontWeight: "bold", color: "#1F2937" }}>
                        SN
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold", color: "#1F2937" }}>
                        File Name
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold", color: "#1F2937" }}>
                        Date Uploaded
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold", color: "#1F2937" }}>
                        Updated by
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold", color: "#1F2937" }}>
                        Status
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tableData.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={5} align="center">
                          <Typography
                            variant="body1"
                            sx={{ py: 2, color: "#6B7280" }}
                          >
                            Logs Not Found
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ) : (
                      tableData.map((row, index) => (
                        <TableRow key={row.id}>
                          <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                          <TableCell>{row.v_file_name}</TableCell>
                          <TableCell>{row.d_upload_date}</TableCell>
                          <TableCell>{row.v_updated_by}</TableCell>
                          <TableCell>{row.v_status}</TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    p: 1,
                  }}
                >
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={total}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </Box>
              </TableContainer>
            </AccordionDetails>
          </Accordion>
        </Card>
      </Container>
    </>
  );
};

export default CapacityBulkUpload;
